import { useMutation, useQueryClient } from 'react-query'
import { ResponseError } from 'umi-request'

import { LocalStorageKeys } from 'shared/utils/keys'
import { LoginUser } from 'shared/types'

export interface StateType {
    isLogged: boolean
    user?: LoginUser
}

export type LoginParamsType = {
    userName: string
    password: string
}

type LoginResult = {
    expires_in: number
    access_token: string
    refresh_token: string
}

// interface RoleResult extends RequestResponse {
//     value: {
//         user: {
//             userName: string
//             institute: string
//         }

//         roles: [
//             {
//                 name: 'string'
//             }
//         ]
//     }
// }

type LoginErrorResult = {
    error: string
    error_description: string
}

async function loginUser(loginToken) {
    try {
        if (loginToken && loginToken.access_token) {
            console.log('🚀 ~ file: useLogin.ts ~ line 63 ~ loginUser ~ response', loginToken)
            // const userJwtData = JwtDecode<JwtLoginUser>(response.access_token)
            localStorage.setItem(LocalStorageKeys.ACCESS_TOKEN, loginToken.access_token)
            // localStorage.setItem(LocalStorageKeys.REFRESH_TOKEN, loginToken.refresh_token)
            localStorage.setItem(LocalStorageKeys.EXPIRES_IN, `${loginToken.expires_On}`)
            return { user: undefined, isLogged: true }
            // const roleResponse = await roleService(userJwtData.sub)
            // const { value, isSuccessful } = roleResponse
            // if (isSuccessful) {
            //     const role = value.roles.map((item) => item.name)
            //     const userData: LoginUser = {
            //         ...value.user,
            //         role,
            //         sub: userJwtData.sub,
            //     }

            //     console.log('USER', userData)
            //     return { user: userData, isLogged: true }
            // }
        }
        return { user: undefined, isLogged: false }
    } catch (err) {
        const errData: LoginErrorResult = { ...err.data }
        throw new Error(`${errData.error} / ${errData.error_description}`)
    }
}

async function logoutUser() {
    Object.keys(localStorage).forEach((key) => {
        if (key !== 'i18nextLng') {
            localStorage.removeItem(key)
        }
    })
}

export default function useLogin() {
    const queryClient = useQueryClient()
    const user = queryClient.getQueryData<StateType>('user') || { user: undefined, isLogged: false }

    const {
        mutate: login,
        error,
        isError,
        isLoading,
    } = useMutation<StateType, ResponseError<LoginErrorResult>, any>((loginData) => loginUser(loginData), {
        onSuccess: (data) => {
            queryClient.setQueryData<StateType>('user', {
                ...user,
                ...data,
            })
            queryClient.invalidateQueries('user')
        },
        onError: () => {
            queryClient.setQueryData<StateType>('user', {
                ...user,
                user: undefined,
                isLogged: false,
            })
        },
    })

    const { mutate: logout } = useMutation(logoutUser, {
        onSuccess: () => {
            queryClient.setQueryData<StateType>('user', {
                ...user,
                user: undefined,
                isLogged: false,
            })
        },
    })
    return { user, login, logout, error, isError, isLoading }
}

// User
// kai.wasternack@link.ch
// wGKMlH7q.

// sil@link.ch
// Link4All$
